import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import clinicService from "../../../../../services/clinic.service";
import {useParams} from "react-router-dom";
import {toast} from "react-toastify";
import Loading from "../../../../common/Loading";

const VerificationCard = () => {
    const [clinicSettings, setClinicSettings] = useState({});
    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const {clinicId} = useParams();

    useEffect(() => {
        setIsLoading(true);
        clinicService
            .getClinicById(clinicId)
            .then((res) => {
                console.log(res.data.verification);
                setClinicSettings(res.data.verification);
                setValue("email", res.data.verification.email);
                setValue("phone", res.data.verification.phone);
                setValue("sms", res.data.verification.sms);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                toast.error("Error while getting Clinic Info", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    }, []);

    const sendVerification = (verificationType) => {
        clinicService.sendVerification(clinicId, verificationType)
            .then(res => {
                toast.success(verificationType + " Verification Request Sent", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err => {
                toast.error("Error while sending Verification Request", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
    }
    const onSubmit = (data) => {
        setIsLoading(true);
        for (const key in data) {
            data[key] ? (data[key] = 1) : (data[key] = 0);
        }
        data["clinicId"] = clinicId;
        clinicService
            .updateVerification(clinicId, data)
            .then((res) => {
                setClinicSettings(res.data);
                setIsLoading(false);
                toast.success("Updated Verification", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .catch((err) => {
                setIsLoading(false);
                toast.error("Error while updating Verification", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };

    return (
        <div className="col-md-4">
            <div className="card card-border shadow-none mb-3">
                <div className="card-body">
                    <div className="d-flex justify-content-between">
                        <div className="card-title"><i className="bi bi-shield-check"></i> Verification</div>
                        <div>
                            {isEditing ? (
                                <button
                                    className="btn btn-danger btn-sm mt-3"
                                    onClick={() => setIsEditing(false)}
                                    title="Close"
                                >
                                    <i className="bi bi-x-square bi-sm"></i>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-outline-primary btn-sm mt-3"
                                    onClick={() => setIsEditing(true)}
                                >
                                    <i className="bi bi-pencil-square bi-sm"></i> Edit
                                </button>
                            )}
                        </div>
                    </div>

                    {isLoading ? (
                        <Loading/>
                    ) : isEditing ? (
                        <>
                            <hr/>
                            <div className="d-flex justify-content-between">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-group mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            {...register("email")}
                                        />
                                        <label htmlFor="email" className="form-check-label ms-1">
                                            {" "}
                                            Email{" "}
                                        </label>
                                    </div>
                                    <div className="break"></div>
                                    <div className="form-group mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            {...register("sms")}
                                        />
                                        <label htmlFor="sms" className="form-check-label ms-1">
                                            {" "}
                                            SMS
                                        </label>
                                    </div>
                                    <div className="break"></div>
                                    <div className="form-group mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            {...register("phone")}
                                        />
                                        <label htmlFor="phone" className="form-check-label ms-1">
                                            {" "}
                                            Phone
                                        </label>
                                    </div>
                                    <div className="break"></div>
                                    <button type="submit" className="btn btn-success btn-sm"><i className="bi bi-floppy"></i> Save</button>
                                </form>
                                <div className="d-flex flex-column">
                                    <button className="btn btn-outline-success btn-sm" onClick={() => {
                                        sendVerification("Email")
                                    }}><i className="bi bi-send"></i> Email
                                    </button>
                                    <div className="break"></div>
                                    <button className="btn btn-outline-success btn-sm" onClick={() => {
                                        sendVerification("SMS")
                                    }}><i className="bi bi-send"></i> SMS
                                    </button>
                                    <div className="break"></div>
                                    <button className="btn btn-outline-success btn-sm" onClick={() => {
                                        sendVerification("Phone")
                                    }}><i className="bi bi-send"></i> Phone
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <i className="bi bi-envelope"></i> Email
                                    {clinicSettings.email ? (
                                        <span className="badge status-completed text-success small ms-3">Verified</span>
                                    ) : (
                                        <span
                                            className="badge status-incomplete text-danger small ms-3">Not Verified</span>
                                    )}
                                </li>
                                <li className="list-group-item">
                                    <i className="bi bi-chat-left-text"></i> SMS
                                    {clinicSettings.sms ? (
                                        <span className="badge status-completed text-success small ms-3">Verified</span>
                                    ) : (
                                        <span
                                            className="badge status-incomplete text-danger small ms-3">Not Verified</span>
                                    )}
                                </li>
                                <li className="list-group-item">
                                    <i className="bi bi-phone"></i> Phone
                                    {clinicSettings.phone ? (
                                        <span className="badge status-completed text-success small ms-3">Verified</span>
                                    ) : (
                                        <span
                                            className="badge status-incomplete text-danger small ms-3">Not Verified</span>
                                    )}
                                </li>
                            </ul>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerificationCard;
